import { IHttpService } from "frontend-core";
import { inject, injectable } from "tsyringe";
import { IReportService } from "@/services/IReportService";
import { IReportDTO, Report } from "@/models/Report";

@injectable()
export class ReportService implements IReportService {
  constructor(
    @inject("IHttpService")
    private readonly http: IHttpService,
  ) {}

  async getList(): Promise<Report[]> {
    let result: any = null;
    await this.http.api.get<IReportDTO[]>(`/reports`).then(res => {
      result = res.data.map(e => new Report(e));
    });

    return result;
  }

  async getRequest(
    dateFrom: string,
    dateTo: string,
    reportType: string,
  ): Promise<Report> {
    let result: any = null;
    await this.http.api
      .post<IReportDTO>(`/reports/request`, { dateFrom, dateTo, reportType })
      .then(res => {
        result = new Report(res.data);
      });

    return result;
  }

  async getFile(reportId: number): Promise<Blob> {
    let result: any = null;
    await this.http.api
      .get(`/reports/${reportId}/download`, { responseType: "blob" })
      .then(res => {
        result = res.data;
      });

    return result;
  }

  async getSegmentationReport(agentId: string, dateFrom: string, dateTo: string, reportType: string) {
    let result: any = null;
    await this.http.api
      .post(`/reports/lk_request`, {
        agentId,
        dateFrom,
        dateTo,
        reportType,
      }, { responseType: "blob" })
      .then(res => {
        result = res.data;
      });

    return result;
  }
}
